// Temporary compatibility map until Jobs has a generated tenant field enum again.
export const JobField = {
  DB_TABLE: 'jobs',
  DB_IDENTIFIER: 'jobGUID',
  NAME: 'name',
  NUMBER: 'number',
  STATUS: 'status',
  CLIENT_GUID: 'clientGUID',
  REVENUE_STREAM_GUID: 'revenueStreamGUID',
} as const
